import _ from "lodash";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import { createUseStyles } from "react-jss";
import {
  getHumanizedFromDurationISO,
  StyleTypeContext,
  TranslationContext,
} from "../../../umbilical_tools";
import { InlineIcon } from "@iconify/react";
import jssVariables from "../../../jss_setup";
import mixed_icon from "../../icons/act_mobile_and_printed_icon.svg";

const featuresStyles = createUseStyles({
  list: (props) => ({
    padding: [jssVariables.half_gap, 0],
    display: "grid",
    gridGap: jssVariables.normal_gap,
    ..._.get(props, "customStyles.list", {}),
  }),
  row: (props) => ({
    display: "grid",
    gridTemplateColumns: "max-content 1fr",
    gridGap: jssVariables.normal_gap,
    alignItems: "center",
    textTransform: "capitalize",
    width: "100%",
    ..._.get(props, "customStyles.row", {}),
  }),
  infoRowText: (props) => ({
    width: "100%",
    whiteSpace: "normal",
    fontSize: "medium",
    ..._.get(props, "customStyles.infoRowText", {}),
  }),
  infoRowIcon: (props) => ({
    fontSize: "x-large",
    ..._.get(props, "customStyles.infoRowIcon", {}),
  }),
  infoRowIconTick: (props) => ({
    fontSize: "large",
    ..._.get(props, "customStyles.infoRowIconTick", {}),
  }),
  tickIconContr: (props) => ({
    display: "grid",
    placeItems: "center",
    color: "white",
    background: "#1F9C00",
    height: "1.5rem",
    width: "1.5rem",
    borderRadius: "50%",
    ..._.get(props, "customStyles.tickIconContr", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    list: (props) => ({
      gridTemplateColumns: "1fr 1fr",
      ..._.get(props, "customStyles.list.smallscreen", {}),
    }),
    row: (props) => ({
      fontSize: "large",
      ..._.get(props, "customStyles.row.smallscreen", {}),
    }),
  },
});
const Features = ({ activity }) => {
  const { type, brand, cStyler } = useContext(StyleTypeContext);
  const { t } = useContext(TranslationContext);

  const classes = featuresStyles({
    customStyles: cStyler({
      type,
      brand,
      objName: "actFeaturesStyles",
    }),
  });

  const instConf = _.get(
    _.get(activity, "features", []).find((ftr) =>
      ["istant", "instant"].includes(ftr.value)
    ),
    "label",
    ""
  );

  return (
    <div className={classes.list}>
      {activity.free_cancellation && (
        <div className={classes.row} style={{ color: "#1F9C00" }}>
          <InlineIcon
            icon="mdi:calendar-check"
            className={classes.infoRowIcon}
          />
          {t("freeCancellation")}
        </div>
      )}
      {activity.safety_info.length > 0 && (
        <div className={classes.row}>
          <InlineIcon
            icon="icon-park-solid:handwashing"
            className={classes.infoRowIcon}
          />
          {t("safetyMeasures")}
        </div>
      )}
      {activity.voucher_access_usage && (
        <div className={classes.row}>
          {activity.voucher_access_usage === "MIXED" ? (
            <img
              src={mixed_icon}
              alt=""
              style={{ width: jssVariables.double_gap }}
            />
          ) : (
            <InlineIcon
              icon={
                activity.voucher_access_usage === "PRINTED"
                  ? "mdi:file-document-outline"
                  : activity.voucher_access_usage === "MOBILE"
                  ? "ic:baseline-smartphone"
                  : ""
              }
              className={classes.infoRowIcon}
            />
          )}
          {t(`${_.lowerCase(activity.voucher_access_usage)}Voucher`)}
        </div>
      )}
      {getHumanizedFromDurationISO(
        activity.duration ? activity.duration : activity.validity
      ) && (
        <div className={classes.row}>
          <InlineIcon
            icon="ic:baseline-access-time"
            className={classes.infoRowIcon}
          />
          <div className={classes.infoRowText}>
            {activity.duration ? `${t("duration")}: ` : t("validity")}
            {getHumanizedFromDurationISO(
              activity.duration ? activity.duration : activity.validity
            )}
          </div>
        </div>
      )}
      {_.get(activity, "languages.length", 0) > 0 && (
        <div className={classes.row}>
          <InlineIcon
            icon="ic:baseline-translate"
            className={classes.infoRowIcon}
          />
          {`${t("languages")}:  ${_.get(activity, "languages", [])
            .map((lng) => lng.name)
            .join(", ")}`}
        </div>
      )}
      {instConf && (
        <div className={classes.row}>
          <div className={classes.tickIconContr}>
            <InlineIcon icon="mdi:tick" className={classes.infoRowIconTick} />
          </div>
          {instConf}
        </div>
      )}
    </div>
  );
};
Features.defaultProps = {
  activity: {},
};
Features.propTypes = {
  activity: PropTypes.object.isRequired,
};
export default Features;
